import HookFormInputField from "@/components/form/HookFormInputField";
import AuthContainer from "@/components/ui/authContainer";
import { IconButton } from "@/components/ui/Buttons";
import { useForgetPasswordMutation } from "@/redux/feature/auth/authApi";
import { useAppDispatch } from "@/redux/hooks/hooks";
import {
  forgetPasswordSchema,
  ForgetPasswordValues,
} from "@/validation/form.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Link, ScrollRestoration, useNavigate } from "react-router-dom";
import CheckIcon from "@/assets/icons/WhiteCheck.svg";

const ForgotPassword = () => {
  const [isLoading, setLoading] = useState(false);
  const [forgetPassword] = useForgetPasswordMutation();
  const [success, setSuccess] = useState(false);

  const methods = useForm<ForgetPasswordValues>({
    resolver: zodResolver(forgetPasswordSchema),
  });

  //   Submit handler
  const onSubmit = async (data: ForgetPasswordValues) => {
    console.log(data);
    const redirectUrl = `${window.location.origin}/auth/set-new-password`;
    try {
      setLoading(true);
      const payload = {
        redirectUrl,
        email: data.email,
      };
      await forgetPassword(payload).unwrap();

      toast.success("Password Reset Link sent to your email");
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Something Went Wrong");

      const error = err as { data?: { errorSource?: { message: string }[] } };

      if (error?.data) {
        error?.data?.errorSource?.forEach((item) => {
          toast.error(item.message);
        });
      }

      console.log(err);
    }
  };

  return (
    <AuthContainer
      title="Forgot password"
      subtitle="Enter your email and we’ll send you a reset link"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-7">
          <div>
            <HookFormInputField
              placeholder="Enter Email"
              name="email"
              label="Email"
              className="mb-[6px]"
              icon={
                success && (
                  <div className="bg-blue-700 p-1 rounded-full">
                    <CheckIcon />
                  </div>
                )
              }
            />
            {success && (
              <p className="text-sm text-blue-700 font-semibold">Sent</p>
            )}
          </div>
          <IconButton
            type="submit"
            className="w-full bg-blue-700 text-white mt-7 "
          >
            {isLoading ? (
              <div className="flex space-x-2 justify-center items-center py-2">
                <span className="sr-only">Loading...</span>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce"></div>
              </div>
            ) : (
              "Recover my password"
            )}
          </IconButton>
        </form>
      </FormProvider>
      <p className="text-gray-500 select-none text-sm mt-8 text-center">
        Already have an account?{" "}
        <Link
          to={"/auth/sign-in"}
          className="text-[#17457D] cursor-pointer font-semibold"
        >
          Login
        </Link>
      </p>
      <ScrollRestoration />
    </AuthContainer>
  );
};

export default ForgotPassword;
